import { useDefaultAnalyticsParams } from "core/analytics/analytics-params.hooks";
import { CustomEventProperties } from "core/analytics/analytics.types";
import { useAppInsightsTrackEvent } from "core/analytics/app-insights/app-insights.hooks";
import { initAppInsights } from "core/analytics/app-insights/app-insights.utils";
import { useInitGoogleAnalytics } from "core/analytics/google-analytics/google-analitics.hooks";
import { trackGaEvent } from "core/analytics/google-analytics/google-analitics.utils";
import { initHotJar } from "core/analytics/hotjar/hot-jar.utils";

export const useInitAnalytics = () => {
  useInitGoogleAnalytics();
  initHotJar();
  const appInsightPlugin = initAppInsights();
  return { appInsightPlugin };
};

export const useTrackAnalyticsEvent = () => {
  const defaultParams = useDefaultAnalyticsParams();
  const trackAppInsightsEvent = useAppInsightsTrackEvent();

  return (name: string, params: CustomEventProperties) => {
    trackGaEvent(name, { ...defaultParams, ...params });
    trackAppInsightsEvent(name, { ...defaultParams, ...params });
  };
};
